import * as React from 'react';

// eslint-disable-next-line
import logoUrl from '@talend/icons/src/svg/products/tdc-negative.svg';
import { SidePanel as ReactContainerSidePanel } from '@talend/react-containers';
import { useSubAppHostContext } from '@talend/sub-app-system';

import { SidePanelEntries, SidePanelLink } from '../../types/sub-app-system';
import { getSidePanelEntriesByOrder } from './SidePanel.utils';

type SidePanelItem = { onClick: Function } & SidePanelLink;
type SidePanelItems = { [key: string]: SidePanelItem };
type NavigateFunction = (event: Event, url: string) => void;
type MenuProps = { navigate: NavigateFunction; menuItems: SidePanelEntries };

function generateActions(subAppMenus: SidePanelEntries, navigate: NavigateFunction) {
	return Object.entries(subAppMenus).reduce((acc: SidePanelItems, [key, conf]) => {
		// eslint-disable-next-line no-param-reassign
		acc[key] = {
			...conf,
			onClick: (event: Event): void => navigate(event, conf.href),
		};
		return acc;
	}, {});
}

export function SidePanel({ navigate, menuItems }: MenuProps): React.ReactElement | null {
	const actions = generateActions(menuItems, navigate);

	const { isFullPage } = useSubAppHostContext();
	if (isFullPage || Object.keys(actions).length === 0) {
		return null;
	}

	return (
		<ReactContainerSidePanel
			id="tdc-side-panel"
			actions={getSidePanelEntriesByOrder(actions)}
			backgroundIcon={logoUrl}
		/>
	);
}
